import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { UserApi } from '../app/api/user.api';


export function UpdatePwd(){

    const navigate = useNavigate();
    const user = UserApi();
    const { token } = useParams();

    const [inputs, setInputs] = useState();
    const [status, setStatus] = useState(0);
    const [isLoading, setIsLoading] = useState(false);

    const [showPassword1, setShowPassword1] = useState(false);
    const [showPassword2, setShowPassword2] = useState(false);

    const handleInputs = ( event ) => {
        const { name , value } =  event.target ;
        setInputs( { ...inputs, [name] : value   } ) ;
    }
  
    const handleForm = async ( event ) => {
        event.preventDefault();
        setInputs( { ...inputs, 'code' : token   } ) ;
        setStatus(0);
        setIsLoading(true);

        if(inputs.password === inputs.cpassword )
        { 
            try {
                const {data} = await user.updatePassword(inputs);
                console.log(data);
                setIsLoading(false);
                if( data.success ){
                    navigate('/connexion');
                }
                else{
                    setStatus(-1);
                }
            } catch (err) { 
                setIsLoading(false);
                setStatus(-1);
            }
        }
        else{ 
            setIsLoading(false);
            setStatus(-2); 
        }
    } 

    return (

        <div className="container-fluid">
            <div className="row justify-content-center align-items-center min-vh-100 bg-light px-4">

                {/* ************************************************************************ */}  
                <div className="col-lg-4 col-md-6">
                  <div className="row">
                    <div className="col-md-12 rounded-2 py-4 px-4">

                        <form onSubmit={ handleForm } className="d-flex flex-column">
                          <div className=" d-flex flex-column align-items-center gap-2 mb-4" > 
                            <div className="d-flex mb-3" >
                              <span className="d-flex align-items-center justify-content-center border px-4 py-2 rounded-2 ">
                                 <img src={'../favicon.png'} className="" alt="Logement extérieur" style={{ width: "60px" }} />
                              </span>
                            </div>
                            <span className="lead color-green text-center"> Modification de mot de passe </span>
                          </div>
                          {
                            isLoading && (
                              <div className="d-flex justify-content-center align-items-center mb-4"> 
                                <div className="spinner-border text-success" role="status" aria-label="Chargement"></div>
                              </div>
                            )
                          }
                          {
                            (status === -1) && (
                              <div className="col-md-12 mb-4">
                                <div className="alert alert-danger">
                                  Une erreur est survenue durant le traitement. Veuillez réessayer.
                                </div>
                              </div>
                            )
                          }
                          {
                            status === -2 && (
                              <div className="col-md-12 mb-3">
                                <div className="alert alert-danger">
                                  Erreur! Veuillez revoir votre mot de passe et la confirmation.
                                </div>
                              </div>
                            )
                          }  
                          <div className="d-flex gap-1 mb-2 align-items-center mb-3">
                            <input type={showPassword1 ? "text" : "password"} name="password" placeholder="Mot de passe" className="input border text-secondary p-3 rounded-2 w-100" onChange={handleInputs} required />
                            <span className="d-flex align-items-center border p-3 rounded-2 text-secondary" style={{ cursor: "pointer" }} onClick={() => setShowPassword1(!showPassword1)}>
                              <i className={`bi ${showPassword1 ? "bi-eye-slash" : "bi-eye"}`}></i>
                            </span>
                          </div>
                          <div className="d-flex gap-1 mb-2 align-items-center mb-3">
                            <input type={showPassword2 ? "text" : "password"} name="cpassword" placeholder="Confirmation mot de passe" className="input border text-secondary p-3 rounded-2 w-100" onChange={handleInputs} required />
                            <span className="d-flex align-items-center border p-3 rounded-2 text-secondary" style={{ cursor: "pointer" }} onClick={() => setShowPassword2(!showPassword2)}>
                              <i className={`bi ${showPassword2 ? "bi-eye-slash" : "bi-eye"}`}></i>
                            </span>
                          </div>
                             
                          <button type="submit" className="btn btn-lg btn-green px-4 mt-2"> 
                            Enregistrer <i className="bi bi-arrow-right ms-3"></i>  
                          </button> 

                          <div className="mt-4 text-muted text-center">────────  ────────</div>

                          <div className="d-flex bg-white gap-2 border text-secondary rounded-2 py-3 px-4 text-outline-muted mt-4">
                             Renseigner votre nouveau mot de passe puis le confirmer.
                          </div>

                        </form>

                    </div>
                  </div>
                </div>
                 {/* ************************************************************************ */}  
              
            </div>
        </div>
        
    )
}


